// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1pE8G","insightsList":"newBusinessInsightsMenu_insightsList__1r3uo","active":"newBusinessInsightsMenu_active__1K1vQ"};